
/**
 * The id is important for the infinite scrollcomponent to identify, which is the scroll target.
 */
export const SCROLLABLE_MAIN_PAGE = "scrollable-page"